import qs from 'qs'

import { HOST_ENDPOINT, V1 } from '@Constants/API'
import {
  OAUTH_TOKEN,
  GET_USERS,
  REFRESH_OAUTH_TOKEN,
  SPORT_ALL,
  USERS_TYPE_ALL,
  DRUG_SEARCH,
  SALT_DETAILS,
  IMAGE_SEARCH,
  GET_OTP,
  SIGN_UP,
  USER_CREATE,
  DRUG_SUGGESTION_CREATE,
  COMMON_VISITOR,
  SEND_SIGN_UP_OTP,
  VERIFY_SIGN_UP_OTP,
  AUTH_LOGOUT,
  USER,
} from 'API/EndPoint'

import { noop } from '@Core/Utility'

export const postOathToken = async ({ fetcher, params = {}, body = {} }) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${OAUTH_TOKEN}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      Authorization: 'Basic bmFkYTpuYWRhLWtleQ==',
    },
  }
  return await fetcher(resourceURL, requestOptions, false)
}

export const getUserDetails = async ({
  fetcher = noop,
  params = {},
  userData = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${GET_USERS}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const newHeader = {}
  if (userData?.access_token) {
    newHeader.Authorization = `Bearer ${userData.access_token}`
  }
  const requestOptions = {
    method: 'GET',
    headers: newHeader,
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postRefreshOathToken = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${REFRESH_OAUTH_TOKEN}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postSportAll = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${SPORT_ALL}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postUsersTypeAll = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${USERS_TYPE_ALL}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postDrugSearch = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${DRUG_SEARCH}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postSaltDetail = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${SALT_DETAILS}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postImageSearch = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${IMAGE_SEARCH}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: body,
    // headers: {
    //   'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
    //   'Accept-Encoding': 'gzip, deflate, br',
    //   'Content-Length': '<calculated when request is sent>',
    // },
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postSendOTP = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${GET_OTP}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postUserCreate = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${USER_CREATE}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postDrugSuggestionCreate = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(
    `${HOST_ENDPOINT}/${V1}/${DRUG_SUGGESTION_CREATE}`
  )
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const getCommonVisitor = async ({ fetcher = noop, params = {} }) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${COMMON_VISITOR}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'GET',
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postSendSignUpOTPAPI = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${SEND_SIGN_UP_OTP}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postVerifySignUpOTPAPI = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${VERIFY_SIGN_UP_OTP}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postSignUpOTPAPI = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${SIGN_UP}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const postLogOutAPI = async ({
  fetcher = noop,
  params = {},
  body = {},
}) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${AUTH_LOGOUT}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
  }
  return await fetcher(resourceURL, requestOptions)
}

export const deleteAccountAPI = async ({ fetcher = noop, params = {} }) => {
  const resourceURL = new URL(`${HOST_ENDPOINT}/${V1}/${USER}`)
  resourceURL.search = new URLSearchParams(qs.stringify(params))
  const requestOptions = {
    method: 'DELETE',
  }
  return await fetcher(resourceURL, requestOptions)
}
